import { useEffect } from 'react';
import { applyPageMeta } from '../utils/seo';

export function usePageMeta(title: string, description: string, jsonLd?: Record<string, unknown>) {
  const jsonKey = jsonLd ? JSON.stringify(jsonLd) : '';
  useEffect(() => {
    applyPageMeta(title, description, jsonKey ? (JSON.parse(jsonKey) as Record<string, unknown>) : undefined);
  }, [title, description, jsonKey]);
}
